import { Routes } from '@angular/router';
import { AuthGuard } from '@app/services/guards/auth.guard';

export const DESKTOP_USER_DASHBOARD_ROUTES: Routes = [
  {
    path: 'user',
    loadComponent: () =>
      import('../pages/user-dashboard/user-dashboard.component'),
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'profile',
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('../pages/user-profile/user-profile.component'),
      },
      {
        path: 'bookings',
        loadComponent: () =>
          import('../pages/user-bookings/user-bookings.component'),
      },
      {
        path: 'wishlist',
        loadComponent: () =>
          import('../pages/user-wishlist/user-wishlist.component'),
      },
      {
        path: 'referrals',
        loadComponent: () =>
          import('../pages/user-referral/user-referral.component'),
      },
      {
        path: 'coupons',
        loadComponent: () =>
          import('../pages/user-coupon/user-coupon.component'),
      },
      {
        path: 'vouchers',
        loadComponent: () =>
          import('../pages/user-gift-card/user-gift-card.component'),
      },
    ],
  },
];

export const MOBILE_USER_DASHBOARD_ROUTES: Routes = [
  {
    path: 'user/profile',
    loadComponent: () => import('../pages/user-profile/user-profile.component'),
    canActivate: [AuthGuard],
  },
  {
    path: 'user/bookings',
    loadComponent: () =>
      import('../pages/user-bookings/user-bookings.component'),
    canActivate: [AuthGuard],
  },
  {
    path: 'user/wishlist',
    loadComponent: () =>
      import('../pages/user-wishlist/user-wishlist.component'),
    canActivate: [AuthGuard],
  },
  {
    path: 'user/referrals',
    loadComponent: () =>
      import('../pages/user-referral/user-referral.component'),
    canActivate: [AuthGuard],
  },
  {
    path: 'user/coupons',
    loadComponent: () => import('../pages/user-coupon/user-coupon.component'),
    canActivate: [AuthGuard],
  },
  {
    path: 'user/vouchers',
    loadComponent: () =>
      import('../pages/user-gift-card/user-gift-card.component'),
  },
  {
    path: 'user',
    loadComponent: () =>
      import('../pages/user-navigation/user-navigation.component').then(
        (m) => m.UserNavigationComponent,
      ),
    canActivate: [AuthGuard],
  },
];
